import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBorderLeftComponent } from "./med-icon-border-left.component";

@NgModule({
  declarations: [
    MedIconBorderLeftComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBorderLeftComponent,
  ],
})
export class MedIconBorderLeftModule { }
